const ContainerIndex = () => import("./containers/index.vue");
const NewContainer = () => import("./containers/_pages/create-container.vue");
const ContainerEdit = () => import("./containers/_pages/view.vue");
const ContainerManifest = () => import("./containers/_pages/manifest.vue");
const ClientInvoice = () => import("./containers/_pages/invoice.vue");
const InvoicesIndex = () => import("./invoices/index.vue");
const InvoicesList = () => import("./invoices/list.vue");
const ViewInvoice = () => import("./invoices/view.vue");
const PaymentsIndex = () => import("./payments/index.vue");
// expenses
const ExpensesIndex = () => import("./expenses/index.vue");
const ExpensesList = () => import("./expenses/list.vue");
// profit
const ProfitIndex = () => import("./profit/index.vue");
// end
export default [
  {
    path: "/container/profit",
    component: ProfitIndex,
  },
  {
    path: "/freight/containers",
    component: ContainerIndex,
  },
  {
    path: "/freight/containers/manifest/:id",
    component: ContainerManifest,
  },
  {
    path: "/new-freight-container",
    component: NewContainer,
  },
  {
    path: "/edit-freight-container/:id",
    component: ContainerEdit,
  },
  {
    path: "/manifest/invoice/:id",
    component: ClientInvoice,
  },
  {
    path: "/view/manifest/invoice/:id",
    component: ViewInvoice,
  },
  {
    path: "/freight/invoices",
    component: InvoicesIndex,
  },
  {
    path: "/freight/invoices/:id",
    component: InvoicesList,
  },
  {
    path: "/freight/payments",
    component: PaymentsIndex,
  },
  {
    path: "/freight/expenses",
    component: ExpensesIndex,
  },
  {
    path: "/freight/expenses/:id",
    component: ExpensesList,
  },
];
